// Community Vendor Management APIs

/**
 * @function ApiClient#AddVendor
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} vendorData
 * @param {any} options = {}
 */
export async function AddVendor(cid, vendorData, options = {}) {
  return await this._post(`/community/${cid}/vendor`, vendorData, options);
}

/**
 * @function ApiClient#UpdateVendor
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} vendorData
 * @param {any} options = {}
 */
export async function UpdateVendor(cid, vendorData, options = {}) {
  return await this._put(`/community/${cid}/vendor`, vendorData, options);
}

/**
 * @function ApiClient#GetVendorList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetVendorList(cid, { sortBy, sortDesc, page, itemsPerPage, search }, options = {}) {
  if (!search) search = "";
  return await this._get(`/community/${cid}/vendor_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&ss=${search}`, options);
}

/**
 * @function ApiClient#GetVendorListSimple
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetVendorListSimple(cid, options = {}) {
  return await this._get(`/community/${cid}/vendor_list_simple`, options);
}

/**
 * @function ApiClient#DeleteVendor
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} vID
 * @param {any} options = {}
 */
export async function DeleteVendor(cid, vID, options = {}) {
  return await this._delete(`/community/${cid}/vendor/${vID}`, options);
}
